import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Challengesmilo() {
  return (
    <section className="challengesmilo p-100 text_reck">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Project <span>Challenges</span>
            </h2>
            <p>
              The Reck’N project presented various challenges that TekRevol was
              composed to resolve. The leading challenge was to develop an
              interface that offered the best customer experience.
            </p>
            <p>
              This included restructuring the reservation procedure,
              guaranteeing effortless order processing, and allowing natural
              communication between customers and restaurants.
            </p>
            <p>
              Furthermore, the app must improve diners’ socialization, inspiring
              interactions and collective experiences. The challenge was to
              nurture a simulated community within the dining ecosystem.
            </p>
            <p>
              Finally, TekRevol intended to inspire regular customers, rewarding
              loyalty and uplifting customer retention rates.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <div className="client_img_reck">
              <StaticImage
                src="../../../images/case-studies/reckncase/challenge.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={826}
                height={726}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Challengesmilo;
